import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ILeverantorsorderDetail } from "../models/leverantorsorder-detail-model";
import { LeverantorsorderService } from "../services/leverantorsorder.service";
import { ICopyLeverantorsorderHeader, ICopyLeverantorsorderPreview } from "./copy-leverantorsorder.models";

@Injectable({
    providedIn: "root"
})
export class CopyLeverantorsorderService {
    private readonly leverantorsorderService = inject(LeverantorsorderService);

    getPreview(id: number): Observable<ICopyLeverantorsorderPreview> {
        return this.leverantorsorderService.get(id)
            .pipe(map(res => {
                res.leverantorsorderrader.forEach(x => {
                    x.kopiera = true;
                    x.kvantitet = undefined;
                    x.periodFrom = undefined;
                    x.periodTom = undefined;
                });

                return {
                    header: this.mapHeader(res),
                    order: res
                };
            }));
    }

    private mapHeader(source: ILeverantorsorderDetail): ICopyLeverantorsorderHeader {
        return {
            huvudkodInternnummer: source.huvudkodInternnummer,
            besokAdress: source.besokAdress,
            ordernummer: "",
            mattslag: source.mattslag,
            summaLeveransrader: 0,
            periodFrom: undefined,
            periodTom: undefined
        };
    }

}
